import styled from 'styled-components';

export const ErrorFallbackLayout = styled.div`
  .ant-layout-content {
    section {
      background: transparent;
    }
  }
  .ant-layout-footer {
    display: none;
  }
`;

export const ErrorFallbackContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    width: 40%;
  }
`;

export const ErrorFallbackTitle = styled.h3`
  font-family: Nunito;
  font-weight: bold;
  color: black;
  font-size: 1.625rem;
  line-height: 2.188rem;
`;
